module.exports = __webpack_public_path__ + "18b187af9f3635c9f86c0ff5d19f48d7.png";